module.exports = __webpack_public_path__ + "static/img/3069_phase_function_Paper_Points.b572a17.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/3069_phase_function_Paper_Points.png
// module id = gT3b
// module chunks = 0